import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "additionalTableIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.additionalTableIsOpen = false;
    },
    setAdditionalFormOpen(state){
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.additionalTableIsOpen = true;
    },
    setAdditionalFormClose(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.additionalTableIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.additionalTableIsOpen = false;
    }
}
